import type { ReactNode } from 'react';

interface ModuleEmptyStateProps {
  icon: ReactNode;
  iconColor: string;        // e.g. '#6366f1', 'var(--color-brand)'
  title: string;
  description: ReactNode;
  buttonLabel?: ReactNode;
  buttonVariant?: 'solid' | 'outline';  // default: 'outline'
  onButtonClick?: () => void;
  secondaryLabel?: string;   // text link below button (e.g. "Use without Google...")
  onSecondaryClick?: () => void;
}

export function ModuleEmptyState({ icon, iconColor, title, description, buttonLabel, buttonVariant = 'outline', onButtonClick, secondaryLabel, onSecondaryClick }: ModuleEmptyStateProps) {
  const btnClass = `module-empty-state__button${buttonVariant === 'outline' ? ' module-empty-state__button--outline' : ''}`;

  return (
    <div className="module-empty-state">
      <div className="module-empty-state__icon" style={{ background: iconColor.startsWith('var(') ? 'var(--xavior-blue-bg)' : `${iconColor}14` }}>
        {icon}
      </div>
      <div className="module-empty-state__title">{title}</div>
      <div className="module-empty-state__description">{description}</div>
      {buttonLabel && onButtonClick && (
        <button
          type="button"
          className={btnClass}
          style={buttonVariant === 'solid' ? { background: 'var(--color-brand)' } : undefined}
          onClick={onButtonClick}
        >
          {buttonLabel}
        </button>
      )}
      {secondaryLabel && onSecondaryClick && (
        <button
          type="button"
          className="module-empty-state__secondary"
          onClick={onSecondaryClick}
        >
          {secondaryLabel}
        </button>
      )}
    </div>
  );
}
